import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'antd'

export default class Profile extends Component {
  render () {
    const { profile, registrations = [] } = this.props
    return (
      <div className="profile">
        <div className="userRegister">
          <Icon type="user" />
        </div>
        <div className="registerNameBox">
          <span className="registerName">
            {`${profile.firstName} ${profile.lastName}`}
          </span>
        </div>
        <div className="upcomingEventBox">
          {/* <span className="upcomingEvent">
            upcoming event
          </span> */}
        </div>
        <p className="upcomingEventP">
          <span className="blueCircle">
            {registrations.filter(reg => reg.status === 'paid').length}
          </span>
          <span className="upcommingEventTitle">
            Successful registrations
          </span>
        </p>

        <p className="upcomingEventP">
          <span className="blueCircle">
            {registrations.filter(reg => reg.status !== 'paid').length}
          </span>
          <span className="upcommingEventTitle">
            Pending registrations
          </span>
        </p>

        {/* <div className="upcomingEventBox">
          <span className="upcomingEvent">
            PAST EVENTS
          </span>
        </div>

        <p className="upcomingEventP">
          <span className="blueCircle">9</span>
          <span className="upcommingEventTitle">
            Finished Events
          </span>
        </p> */}
      </div>
    )
  }
}

Profile.propTypes = {
  profileInfo: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/App/DashboardPage/Components/Profile.js